import { render, staticRenderFns } from "./CSCardsStyle.vue?vue&type=template&id=019d7a8b&"
import script from "./CSCardsStyle.vue?vue&type=script&lang=js&"
export * from "./CSCardsStyle.vue?vue&type=script&lang=js&"
import style0 from "./CSCardsStyle.vue?vue&type=style&index=0&id=019d7a8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports